








const namespace = 'calendar';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

@Component({
    name: 'CalendarTimeline',
})
export default class CalendarTimeline extends Vue {
    @Prop() private range!: number[];
    @Prop() private boxType!: string;
    @Getter('boxWidth', { namespace }) private boxWidth!: number;
    @Getter('cellHeight', { namespace }) private cellHeight!: number;

    private get getHoursRange() {
        return this.range;
    }

    private printFullHourLabel(hour: number) {
        return hour % 1 === 0 ? `${hour}:00` : ` `;
    }
}
